import React, {useState} from 'react';
import PageHeader from "../../components/PageHeader";
import {Link} from "react-router-dom";
import DataTable from "react-data-table-component";
import {customTableStyles} from "../../utils";
import {Button} from "react-bootstrap";

const HistoryPage = () => {
    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const columns = [
        {
            name: 'User',
            selector: row => row.user,
            sortable: true,
        },
        {
            name: 'Edit Timestamp',
            selector: row => row.editTimestamp,
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row, i) => {
                return (
                    <div className="hstack gap-1 fs-1">
                        <Button
                            aria-label="View Details"
                            onClick={() => alert(`Viewing details for ${row.user}`)}
                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                        >
                            <i className="ri-eye-line"/>
                        </Button>
                    </div>
                )
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    
    const data = [
        {
            user: 'User A',
            editTimestamp: '2024-09-01T10:45:00',
        },
        {
            user: 'User B',
            editTimestamp: '2024-09-05T14:30:00',
        },
        {
            user: 'User C',
            editTimestamp: '2024-09-10T09:20:00',
        },
        {
            user: 'User D',
            editTimestamp: '2024-09-12T16:10:00',
        },
        {
            user: 'User E',
            editTimestamp: '2024-09-14T11:50:00',
        },
        {
            user: 'User F',
            editTimestamp: '2024-09-18T13:05:00',
        },
        {
            user: 'User G',
            editTimestamp: '2024-09-20T15:25:00',
        },
        {
            user: 'User H',
            editTimestamp: '2024-09-22T08:40:00',
        },
        {
            user: 'User I',
            editTimestamp: '2024-09-25T12:35:00',
        },
        {
            user: 'User J',
            editTimestamp: '2024-09-28T10:15:00',
        },
    ];
        
    return (
        <>
            <PageHeader name="Application History"/>
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 justify-content-between">
                                    
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line"/>
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <DataTable
                                    columns={columns}
                                    data={data}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            
        </>
    );
};

export default HistoryPage;